<template>
  <UiOnClickOutside :do="hideContent">
    <div class="ui-base-menu-dropdown component">
      <div class="icon-wrapper" @click="toggleMenu">
        <slot name="icon">
          <div class="default-menu-icon menu-trigger">
            <div class="menu-line top"></div>
            <div class="menu-line middle"></div>
            <div class="menu-line bottom"></div>
          </div>
        </slot>
      </div>
      <div class="content" v-if="isShown" @click="hideContent">
        <slot></slot>
      </div>
    </div>
  </UiOnClickOutside>
</template>

<script>
  import UiOnClickOutside from './UiOnClickOutside'

  export default {
    name: 'UiBaseMenuDropdown',
    props: {
      autoClose: {
        type: Boolean,
        default: true
      },
      listType: {
        type: Boolean,
        default: true
      }
    },

    components: {
      UiOnClickOutside
    },

    data () {
      return {
        isShown: false
      }
    },
    methods: {
      toggleMenu () {
        this.isShown = !this.isShown
      },
      hideContent () {
        if (this.isShown) this.isShown = false
      }
    },

    mounted () {
      if (!this.$slots.default) {
        throw new Error('Please define default slot content!')
      }
      if (this.listType && (this.$slots.default[0].tag !== 'ul')) {
        throw new Error(`Wrong template! Please use <ul> tag as default slot to define menu list:
        <UiMenu>
          <ul>
            <li>hello</li>
            <li>bye</li>
          </ul>
        <UiMenu>
        `)
      }
    }
  }
</script>

<style lang="scss">
  .ui-base-menu-dropdown.component {
    display: flex;
    position: relative;
    .icon {
    }
    .menu-trigger {
      cursor: pointer;
      position: absolute;
      width: 42px;
      height: 42px;
      right: 20px;
      top: 0;

      &:hover {
        .menu-line {
          &:before {
            width: 100%;
          }
        }

        .close-trigger {
          &:before {
            width: 100%;
          }
        }
      }

      .menu-line {
        display: block;
        width: 100%;
        height:4px;
        background: $prime-color;
        margin-bottom: 6px;
        transform: rotate(-45deg);
        position: relative;

        :before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          display: block;
          width: 0;
          height: 100%;
          background-color: $dark-color;
          transition: $slide;
        }

        &.top {
          width: 50%;
        }

        &.middle {
          &:before {
            left: auto;
            right: 0;
          }
        }

        &.bottom {
          width: 50%;
          margin-left: 50%;
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/UiBaseMenuDropdown.vue